export default __webpack_public_path__ + "static/squares-58b14e5c9cdbf06bc5158206b24c2b46.png";